import {blue, brown, green, orange, red} from "@mui/material/colors";

export const shippingStatuses = [
  {
    key: 'PENDING',
    label: 'Confirmation Pending',
    color: blue[600],
    bgColor: blue[50],
  },
  {
    key: 'PENDING_DROP_OFF',
    label: 'Confirmed, Shipping Pending',
    color: blue[800],
    bgColor: blue[100],
  },
  {
    key: 'SHIPPED',
    label: 'Shipped',
    color: orange[700],
    bgColor: orange[100],
  },
  {
    key: 'FAILED',
    label: 'Shipping Failed',
    color: red[700],
    bgColor: red[100],
  },
  {
    key: 'DELIVERED',
    label: 'Delivered, Confirmation Pending',
    color: green[600],
    bgColor: green[50],
  },
  {
    key: 'BUYER_CONFIRMED',
    label: 'Received, Payment Pending',
    color: green[800],
    bgColor: green[100],
  }
];

export const paymentStatuses = [
  {
    key: 'PENDING',
    label: 'Pending',
    color: blue[600],
    bgColor: blue[50],
  },
  {
    key: 'PAID',
    label: 'Paid',
    color: green[700],
    bgColor: green[100],
  },
  {
    key: 'FAILED',
    label: 'Payment Failed',
    color: red[800],
    bgColor: red[200],
  },
];

export const orderStatuses = [
  {
    key: 'CANCELED',
    label: 'Canceled',
    color: red[700],
    bgColor: red[100],
  },
  {
    key: 'AVAILABLE',
    label: 'Available',
    color: green[600],
    bgColor: green[50],
  },
  {
    key: 'OUT_OF_STOCK',
    label: 'Out of stock',
    color: brown[700],
    bgColor: brown[100],
  },
];

export enum FedexPickupType {
  contactFedexToSchedule = 'CONTACT_FEDEX_TO_SCHEDULE',
  dropOffAtFedexLocation = 'DROPOFF_AT_FEDEX_LOCATION',
  useScheduledPickup = 'USE_SCHEDULED_PICKUP',
  onCall='ON_CALL',
  packageReturnProgram = 'PACKAGE_RETURN_PROGRAM',
  regularStop='REGULAR_STOP',
  tag='TAG'

}

export const fedexShippingMap: any = {
  'fedex-ground': 'GROUND_HOME_DELIVERY',
  'fedex-2-day': 'FEDEX_2_DAY',
  'fedex-priority-overnight': 'PRIORITY_OVERNIGHT',
}

/** Set true to skip FedEx rate API validation on checkout (uses surcharges only). Set false when FedEx rates work again. */
export const BYPASS_FEDEX_RATE_CHECK = true;

export const isRefrigerated = (data: any) => {
  let refrigerated = false;
  data.forEach((cartItem: any) => {
    if (cartItem.item.isFrozen) {
      refrigerated = true;
    }
  });

  return refrigerated;
}

export const fedExPackageWeightCoefficient = 0.3;

const shippingRateRequestDefaultData = {
  accountNumber: {
    value: Number(process.env.REACT_APP_FEDEX_ACCOUNT_NUMBER)
  },
  carrierCodes: ["FDXE", "FDXG", "FXCC"],
  rateRequestControlParameters: {
    returnTransitTimes: false,
    servicesNeededOnRateFailure: true,
    variableOptions: 'FREIGHT_GUARANTEE',
    rateSortOrder: 'SERVICENAMETRADITIONAL'
  },
}

export const getShippingRateRequestData = (sellerData: any, buyerData: any, serviceType: string, packageItemsCount: number) => {
  return {
    ...shippingRateRequestDefaultData,
    requestedShipment: {
      pickupType: FedexPickupType.dropOffAtFedexLocation,
      groundShipment: true,
      rateRequestType: ["ACCOUNT"],
      serviceType: serviceType,
      shipper: {
        accountNumber: {
          value: Number(process.env.REACT_APP_FEDEX_ACCOUNT_NUMBER)
        },
        address: {
          city: sellerData.PharmacyAddress[0].city,
          countryCode: 'US',
          postalCode: sellerData.PharmacyAddress[0].zipCode,
          residential: true,
          stateOrProvinceCode: sellerData.PharmacyAddress[0].State.code,
          streetLines: [sellerData.PharmacyAddress[0].address],
        },
        contact: {
          personName: sellerData.PharmacyDetail.managerContactName,
          companyName: sellerData.legalName,
          emailAddress: sellerData.email,
          phoneNumber: sellerData.mobile,
        },
      },
      recipient: {
        address: {
          city: buyerData.PharmacyAddress[0].city,
          countryCode: 'US',
          postalCode: buyerData.PharmacyAddress[0].zipCode,
          residential: true,
          stateOrProvinceCode: buyerData.PharmacyAddress[0].State.code,
          streetLines: [buyerData.PharmacyAddress[0].address],
        },
        contact: {
          personName: buyerData.PharmacyDetail.managerContactName,
          companyName: buyerData.legalName,
          emailAddress: buyerData.email,
          phoneNumber: buyerData.mobile,
        }
      },
      requestedPackageLineItems: [
        {
          groupPackageCount: 1,
          weight: {
            units: 'LB',
            value: Math.ceil(
              fedExPackageWeightCoefficient * (packageItemsCount + 1)
            ),
          },
          // dimensions: {
          //   length: 12,
          //   width: 6,
          //   height: 8,
          //   units: 'IN',
          // },
        }
      ],
    }
  }
}
